// extracted by mini-css-extract-plugin
export var btn = "personalForm-module--btn--9RJGu";
export var form = "personalForm-module--form--xpLzy";